<template>
  <div v-if="userEmailsNotInMailbook.length > 0">
    <RevInfoBlock
      class="relative"
      :icon="IconWarning"
      :title="i18n(translations.warningTitle)"
      variant="default"
    >
      <RevButtonIcon
        :alternative-text="i18n(translations.toggleMore)"
        class="absolute right-16 top-12 h-32 w-32 cursor-pointer"
        :class="{ 'rotate-180': isOpen }"
        :icon="IconChevronDown"
        variant="secondary"
        @click="isOpen = !isOpen"
      />

      <ul v-if="isOpen" class="flex flex-col gap-4">
        <li
          v-for="email in userEmailsNotInMailbook"
          :key="email"
          class="body-2 break-words break-all"
        >
          {{ email }}
        </li>
      </ul>
    </RevInfoBlock>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from '../Mailbook.translations'

type Props = {
  userEmailsNotInMailbook: string[]
}

defineProps<Props>()

const i18n = useI18n()
const isOpen = ref(false)
</script>
